import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeleteSwitchPointData } from 'src/app/page/masterdata/switch-points/switch-points.component';

@Component({
    selector: 'app-delete-switch-point',
    templateUrl: './delete-switch-point.component.html',
    styleUrls: ['./delete-switch-point.component.scss'],
    standalone: false // NOSONAR
})
export class DeleteSwitchPointComponent implements OnInit {
  content;
  id;
  pageName;

  constructor(public dialogRef: MatDialogRef<DeleteSwitchPointComponent>, 
    @Inject(MAT_DIALOG_DATA) public dataStore: DeleteSwitchPointData) { 
    if(this.dataStore.page == 'switch point'){ // NOSONAR
      this.pageName = "Switch Point";
      this.content = this.dataStore.switchPoint;
      this.id = this.dataStore.id;
    }
  }

  ngOnInit(): void { // NOSONAR 

  }

  close(): void {
    this.dialogRef.close();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  public saveClick() {    
    this.dialogRef.close({data:this.id});
  }
}
